import { Stack, StackProps } from '@mui/material'
import { styled } from 'styles/styled'

export const TypeTabContainer = styled((props: StackProps) => (
  <Stack {...props} width="100%" height="100%" />
))`
  justify-content: space-between;
  padding: 8px 8px 16px;
`
